<script setup lang="ts">
/********************
 * PROPS & EMITS     *
 ********************/
export interface InputTextareaProps {
  cols?: number;
  disabled?: boolean;
  error?: boolean;
  id?: string | null;
  inverted?: boolean;
  label?: string;
  name?: string | null;
  placeholder?: string;
  rows?: number;
}
const props = withDefaults(defineProps<InputTextareaProps>(), {
  cols: 1,
  disabled: false,
  error: false,
  id: null,
  inverted: false,
  label: '',
  name: null,
  placeholder: '',
  rows: 5,
});

/********************
 * REFS & VARS       *
 ********************/
const model = defineModel<string>();
</script>

<template>
  <div
    :class="[`input-wrapper--${props.id}`, props.error ? 'has-error' : '']"
    class="mb-6"
  >
    <div class="input-label__wrapper relative">
      <label
        :for="props.id"
        class="input-label text-left"
      >
        <span>{{ props.label }}</span>
      </label>
      <slot />
    </div>

    <div class="input-field__wrapper relative">
      <textarea
        :id="props.id"
        v-model="model"
        :class="{ 'input--inverted': props.inverted }"
        :cols="props.cols"
        :rows="props.rows"
        :name="props.name || props.id"
        :disabled="props.disabled"
        :placeholder="props.placeholder"
        class="input-field input-field--text px-6 py-4"
      />
    </div>
  </div>
</template>

<style></style>
